<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useLogoutSubscription } from '@/shared/composables/useLogoutSubscription';

import EmptyLayout from '@/shared/layouts/EmptyLayout.vue';
import MainLayout from '@/shared/layouts/MainLayout.vue';

import { uk } from '@nuxt/ui/locale';

useLogoutSubscription();

const route = useRoute();
const layoutName = computed((): 'main' | 'empty' => (route.meta.layout === 'main' ? 'main' : 'empty'));
</script>

<template>
  <UApp
    :locale="uk"
    :toaster="{ progress: false }"
  >
    <UDashboardGroup
      unit="rem"
      storage="local"
    >
      <MainLayout v-if="layoutName === 'main'" />
      <EmptyLayout v-else />
    </UDashboardGroup>
  </UApp>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
@import url('https://fonts.cdnfonts.com/css/arca-majora-3');
</style>

<style></style>
